import { http } from '../../config/axios'

export interface AdministrarFaturaRequest {
  idFatura: string
  valor: number
  descricao: string
  desconto: boolean
}

export default function postFaturaAdministrarService(
  request: AdministrarFaturaRequest
): Promise<string> {
  return http
    .post('/api/fatura/administrar', request)
    .then((res) => res.data as string)
    .catch((error) => {
      console.error('Erro ao administrar fatura', error)
      throw Error(error.response?.data)
    })
}
